import React, { useEffect } from 'react';

import { connect } from 'react-redux';

import moment from 'moment';

import BobPage from '../../../components/BobPage';
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';
import BobTimeStampFilter from '../../../components/RuleExceptionsTable/BobTimestampFilter';
import Navigation from '../Navigation/Navigation';
import ViewContainer from './ViewContainer';

import * as DashboardActions from '../../../actions/dashboardActions';

import * as classes from './EnergyPage.module.css';

const EnergyPage = ({
    dashboardTimePeriod,
    desiredInterval,
    setDashboardStartTimestamp,
    setDashboardEndTimestamp,
    setDashboardTimePeriod,
    setDashboardIsCurrentTimestamp,
    ...props
}) => {

    useEffect(() => {
        if (dashboardTimePeriod === 'Current') {
            setDashboardIsCurrentTimestamp(false);
            setDashboardTimePeriod('Previous');
            setDashboardStartTimestamp(moment().set('minute', Math.floor(moment().minute() / desiredInterval) * desiredInterval).subtract(1, 'd').local());
            setDashboardEndTimestamp(moment().local());
        }
    }, [dashboardTimePeriod]);

    return (
        <BobPage>
            <div className={classes.CompanyPage}>
                <div className={classes.BreadcrumbPanel}>
                    <Breadcrumb />
                </div>
                <div className={classes.HeaderPanel}>
                    <div className={classes.NavigationPanel}>
                        <Navigation />
                    </div>
                    <div className={classes.Date}>
                        <BobTimeStampFilter
                            application="energy"
                            className={classes.TimestampOverride}
                            maxDate={moment().local()}
                        />
                    </div>
                </div>
                <div className={classes.TitlePanel}>
                    Energy
                </div>
                <div className={classes.TablePanel}>
                    <ViewContainer />
                </div>
            </div>
        </BobPage>
    );
};

const mapDispatchToProps = {
    ...DashboardActions
};

const mapStateToProps = state => {
    return {
        dashboardTimePeriod: state.dashboard.dashboardTimePeriod,
        desiredInterval:     state.dashboard.desiredInterval
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EnergyPage);
